import React from 'react';
import About from '../About/About';
import Footer from '../Footer/Footer';
import Home from '../Home/Home';
import Projects from '../Projects/Projects';
// import BackgroundTitle from '../UI/BackgroundTitle/BackgroundTitle';
import Loading from '../UI/Loading/Loading';
// import classes from './App.module.scss';

let appLoaded = false;

function App(props) {

  const showAllProjectsHandler = ()=> props.history.push('/projects');

  return (
    <>
      {/* <BackgroundTitle /> */}

      { props.loaded || appLoaded ? (
        <>
          <Home />
          <About />
          <Projects showAllProjectsHandler={showAllProjectsHandler} />

          <Footer />
        </>
      ) : <Loading />}

    </>
  );
}

export default App;
